import store from "@/store";
import i18n from "@/locales/index"

export default function RequestHeader() {
    let { accessToken } = store.getters.userInfo || {};
    let header = {
        'Content-Type': 'application/json',
        'Request-Type': 'Client-Admin',
        "Lang": i18n.global.locale.value || 'kk'
    };

    if (accessToken) {
        header['Authorization'] = `Bearer ${accessToken}`;
    }

    return header;
}
